export function ContactPage() {
  return (
    <section className="contact-page">
      <h1>Contact</h1>
      <p>Send me an email at my first name @ this domain dot com.</p>
      <p> You can also find me on <a href="https://twitter.com/defusionista">X</a>, <a href="https://linkedin.com/in/defusion">LinkedIn</a>, <a href="https://github.com/auridian">GitHub</a>, <a href="https://defusion.substack.com/">Substack</a>, and Signal (at auridian dot 42).</p>
    </section>
  );
}
